<template>
  <DefaultResult></DefaultResult>
</template>

<style lang="scss" scoped>
.wrap {
  max-width: 1440px;
  margin: 0 auto;
  height: 100vh;
}

.loading_mask {
  overflow: hidden;
}

.disabled {
  pointer-events: none;
  cursor: none;
}

.d-none {
  display: none !important;
}

.card_section_title_icon {
  margin-left: 23px;
  vertical-align: bottom;
}
</style>
